import { useCallback, useMemo } from 'react';
import { useAuthContext } from '@/auth/useAuthContext';
import { CAKTO_MEMBERS_V2_EXPERIMENTAL_FLAG } from '@/consts/flags';

/**
 * Resolve quais áreas members legadas o produtor pode selecionar.
 *
 * O backend é a fonte de verdade porque o acesso depende do histórico de
 * produtos do owner. O fallback existe exclusivamente para deploy backend-
 * primeiro/frontend-antigo e só mantém a feature flag já conhecida da V2.
 */
export function useMembersDeliveryAccess() {
  const { user } = useAuthContext();

  return useMemo(() => {
    const serverAccess = user?.contentDeliveryAccess;

    if (
      typeof serverAccess?.cakto === 'boolean' &&
      typeof serverAccess?.cakto_v2 === 'boolean'
    ) {
      return serverAccess;
    }

    return {
      cakto: false,
      cakto_v2:
        Array.isArray(user?.experimental_features) &&
        user.experimental_features.includes(CAKTO_MEMBERS_V2_EXPERIMENTAL_FLAG),
    };
  }, [user]);
}

/**
 * Recarrega o usuário para o acesso às áreas members legadas acompanhar a exclusão de produto.
 *
 * O acesso vem junto do usuário carregado no login e depende dos produtos não deletados do owner.
 * Excluir o último produto com V1 ou V2 tira o acesso no backend, e sem recarregar a tela seguia
 * oferecendo a área que o save recusa ("… ainda não está disponível para esta conta.").
 */
export function useRefreshMembersDeliveryAccess() {
  const { refreshUser } = useAuthContext();

  return useCallback(() => {
    Promise.resolve(refreshUser?.({ forceUpdate: true })).catch(() => {});
  }, [refreshUser]);
}

export default useMembersDeliveryAccess;
